const assets = "/assets";
const checkout = "/checkout";
const confirm = "/confirm";
const equipment = "/equipment";
const home = "/";
const location = "/location";
const returnAddress = "/return-address";

export { assets, checkout, confirm, equipment, home, location, returnAddress };
